import { render } from "./MovieBooking.vue?vue&type=template&id=bf704026"
import script from "./MovieBooking.vue?vue&type=script&lang=js"
export * from "./MovieBooking.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__